import API from "@/api";

export const LoginPlugin = {
  install(Vue, { router }) {
    console.log("Login plugin:::", Vue.prototype, router);

    const showError = (error) => {
      console.error("update or sync source info error:::", error);
      Vue.prototype.$message.error("图片、视频资源将无法展示，推出重新登陆");
    };

    const updateSourceInfo = async () => {
      try {
        const userInfo = localStorage.getItem("userInfo");
        if (Vue.prototype.$sourceInfo || !userInfo) return;
        const r = await API.getSourceList();
        if (r.code !== 200) throw new Error(r.tip);
        syncSourceInfo(r.data);
        // const sourceInfo = [
        //   {
        //     type: "IMAGE",
        //     domain: [{ url: "https://69vfo.com" }],
        //   },
        //   {
        //     type: "VID",
        //     domain: [{ url: "https://26wjt.com" }],
        //   },
        //   {
        //     type: "AUDIO",
        //     domain: [{ url: "https://sswmvn.hdpbtwyc.cn" }],
        //   },
        // ];
        // syncSourceInfo(sourceInfo);
      } catch (error) {
        showError(error);
      }
    };

    const syncSourceInfo = (info) => {
      info = info || [];
      Vue.prototype.$sourceInfo = info;
      try {
        let _index = localStorage.getItem("overallSituationLine") || 0;
        Vue.prototype.$imgUrls = [
          ...findUrls(info, "IMAGE"),
          ...findUrls(info, "AdminImage"),
        ];
        Vue.prototype.$vidUrls = findUrls(info, "VID");
        Vue.prototype.$audUrls = findUrls(info, "AUDIO");
        let imgUrl =
          Vue.prototype.$imgUrls[_index] || Vue.prototype.$imgUrls[0];
        let vidUrl =
          Vue.prototype.$vidUrls[_index] || Vue.prototype.$vidUrls[0] || {};
        let audUrl =
          Vue.prototype.$audUrls[_index] || Vue.prototype.$audUrls[0] || {};
        Vue.prototype.$imgUrl = imgUrl.url;
        Vue.prototype.$vidUrl = vidUrl.url || '';
        Vue.prototype.$audUrl = audUrl.url || '';
      } catch (error) {
        showError(error);
      }
    };

    const findUrls = (info, key) => {
      return (info.find((kv) => kv.type === key) || { domain: [] }).domain;
    };

    Vue.prototype.$syncSourceInfo = syncSourceInfo;
    Vue.prototype.$setOverallSituationLine = (index) => {
      localStorage.setItem("overallSituationLine", index);
      let imgUrl = Vue.prototype.$imgUrls[index] || Vue.prototype.$imgUrls[0];
      let vidUrl = Vue.prototype.$vidUrls[index] || Vue.prototype.$vidUrls[0] || {};
      let audUrl = Vue.prototype.$audUrls[index] || Vue.prototype.$audUrls[0] || {};
      Vue.prototype.$imgUrl = imgUrl.url;
      Vue.prototype.$vidUrl = vidUrl.url || '';
      Vue.prototype.$audUrl = audUrl.url || '';
      location.reload();
    };

    router.beforeEach(async (to, from, next) => {
      if (to.path != "/" && to.path != "/login") {
        await updateSourceInfo();
      }
      return next();
    });
  },
};
